import { prefixWithNameAndCode } from "./phonePrefixes";
import ReactFlagsSelect from "react-flags-select";
import { useRef } from "react";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PhoneInput = (props) => {
  const handleClick = () => {
    setTimeout(() => {
      const searchInput = document.querySelector(
        ".ReactFlagsSelect-module_filterBox__3m8EU input"
      );
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  };

  const createLabels = () => {
    let labels = {};
    prefixWithNameAndCode.forEach(
      (countryInfo) =>
        (labels[countryInfo.countryCode] = {
          primary: countryInfo.label,
          secondary: countryInfo.value,
        })
    );
    return labels;
  };

  return (
    <div
      className={`phone-group mb-3 ${
        props.phoneError || props.phoneEmpty ? "error-div-highlight" : ""
      }`}
    >
      <label
        htmlFor="Phone"
        className="label-checkout"
        style={props.isInformationContent ? { left: "7.9em" } : {}}
      >
        {props.phonePlaceholder}
      </label>
      <div
        onClick={handleClick}
        className={`input-group${props.isInformationContent ? " mt-0" : " px-3"}`}
      >
        <ReactFlagsSelect
          className="prefix-dropdown pb-0"
          styles={{ minWidth: "50%" }}
          id={props.flagId}
          selectButtonClassName="prefix-box justify-content-center"
          searchable
          selected={props.flagValue?.toUpperCase()}
          selectedSize={12}
          optionsSize={15}
          showSelectedLabel={false}
          showOptionLabel={true}
          showSecondaryOptionLabel={true}
          showSecondarySelectedLabel={true}
          customLabels={createLabels()}
          placeholder={props.flagPlaceholder}
          onSelect={(code) => {
            props.onFlagChange(
              prefixWithNameAndCode.find((obj) => obj.countryCode == code)
            );
          }}
        />

        <input
          autoComplete="tel-national"
          className="form-control floating-label-field floating-label-field--s1"
          style={{
            borderRadius: "0 5px 5px 0",
          }}
          placeholder={props.phonePlaceholder}
          type="tel"
          id={props.phoneId}
          value={props.phoneValue}
          onChange={(e) => props.onNumberChange(e.target.value)}
          onBlur={() => {
            if (props.onBlurMethod != null) {
              props.onBlurMethod();
            }
          }}
        />
      </div>
      <div
        className={`field-error phone-error ${
          props.phoneError || props.phoneEmpty ? "" : "hidden-error"
        }`}
        style={{
          marginLeft: props.isInformationContent ? "0.1em" : "",
          display: props.phoneError || props.phoneEmpty ? "flex" : "none",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ paddingRight: "2px" }}
          size="sm"
          fixedWidth
        />
        {props.phoneError || props.phoneEmpty}
      </div>
    </div>
  );
};

export default PhoneInput;
